import axiosInstance from "../../Utils/axiosInstance";

export type PnlRow = {
  book: string;
  strategy: string;
  daily_change: number;
};

export const fetchPnlSummaryView3 = async (): Promise<PnlRow[]> => {
  const res = await axiosInstance.get<PnlRow[]>("/paper-app/pnl-summary-view3/");
  return res.data ?? [];
};


export const updateDailyChangeCloud2 = async (): Promise<void> => {
  await axiosInstance.get("/paper-app/update-dailychange-cloud2/");
};